import { Link } from 'react-router'
import moment from 'moment-timezone'
import { RunManifest } from '@signifyd/cypress'
import RunStatusTag from 'core/components/RunStatusTag/RunStatusTag'
import PrLink from 'pages/Dashboard/PrLink'
import { ColumnsType } from 'antd/lib/table'

export const getColumns = (
  projectName: string,
  navPrefix: string
): ColumnsType<RunManifest> => [
  {
    title: 'Run ID',
    dataIndex: 'runId',
    key: 'runId',
    sorter: (a, b) => a.runId.localeCompare(b.runId),
    render: (runId: string) => {
      return (
        <Link to={`/playwright/${projectName}/${runId}${navPrefix}`}>
          {runId}
        </Link>
      )
    },
  },
  {
    title: 'Timestamp',
    dataIndex: 'datetime',
    key: 'datetime',
    render: (datetime: string) => new Date(datetime).toLocaleString(),
    sorter: (a, b) => {
      if (!a.datetime || !b.datetime) {
        return Infinity
      }

      return new Date(a.datetime).getTime() - new Date(b.datetime).getTime()
    },
    defaultSortOrder: 'descend',
    sortDirections: ['ascend', 'descend', 'ascend'],
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    filters: [
      { text: 'Passed', value: 'passed' },
      { text: 'Failed', value: 'failed' },
      { text: 'Skipped', value: 'skipped' },
      { text: 'Flaky', value: 'flaky' },
      { text: 'Timed Out', value: 'timedOut' },
      { text: 'Interrupted', value: 'interrupted' },
    ],
    onFilter: (value, record) => record.status === value,
    render: (record) => {
      const status = record ?? 'unknown'

      return <RunStatusTag runStatus={status} />
    },
  },
  {
    title: 'Duration (minutes)',
    dataIndex: 'totalDuration',
    key: 'totalDuration',
    render: (value) =>
      moment(moment.duration(value).asMilliseconds()).format('mm:ss'),
  },
  {
    title: 'Branch',
    dataIndex: 'branchName',
    key: 'branchName',
  },
  {
    title: 'Pull Request',
    dataIndex: 'pullRequestNumber',
    key: 'pullRequestNumber',
    render: (prNumber) => <PrLink prNumber={prNumber} />,
  },
]
